import React from "react";
import * as style from "./ApplicationAccessFooter.module.scss";
import { Box } from "@mui/material";
import Button from "../../Components/Common/CprimeButton";
interface ApplicationAccessFooterProps {
  isClear?: boolean;
  isNext?: boolean;
  isBack?: boolean;
  isSubmit?: boolean;
  isNextDisabled?: boolean;
  isSubmitDisabled?: boolean;
  onClear?: () => any;
  onNext?: () => any;
  onBack?: () => any;
  onSubmit?: () => any;
}

const ApplicationAccessFooter: React.FC<ApplicationAccessFooterProps> = ({
  isClear = true,
  isNext = true,
  isBack = true,
  isSubmit = true,
  isNextDisabled = false,
  isSubmitDisabled = false,
  onClear,
  onBack,
  onNext,
  onSubmit,
}) => {
  const scssClass = style as any;
  return (
    <div className={scssClass.responsiveCard}>
      <div className={scssClass.cardContent}>
        <div className={scssClass.buttonSection}>
          <div>
            {isBack && (
              <Box onClick={onBack} className={scssClass?.backButton}>
                Back
              </Box>
              // <Button
              //   label={"Back"}
              //   variant="tertiary"
              //   sx={{ marginLeft: "4px", marginRight: "4px", border: "none" }}
              //   onClick={onBack}
              // />
            )}
          </div>
          <div>
            {isClear && (
              <Button
                variant="tertiary"
                sx={{ marginLeft: "4px", marginRight: "4px" }}
                onClick={onClear}
              >
                Clear
              </Button>
            )}
            {isNext && (
              <Button
                variant="primary"
                sx={{ marginLeft: "4px", marginRight: "4px" }}
                onClick={onNext}
                disabled={isNextDisabled}
              >
                Next
              </Button>
            )}
            {isSubmit && (
              <Button
                variant="primary"
                disabled={isSubmitDisabled}
                sx={{ marginLeft: "4px", marginRight: "4px" }}
                onClick={onSubmit}
              >
                Submit
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationAccessFooter;
